import { render, staticRenderFns } from "./ReviewSettings.vue?vue&type=template&id=4e44ad0a&scoped=true"
import script from "./ReviewSettings.vue?vue&type=script&lang=js"
export * from "./ReviewSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e44ad0a",
  null
  
)

export default component.exports